export default async (file) => await (await fetch(file)).text()